module.exports = __webpack_public_path__ + "img/no-mobile-farmer-on-computer.3c2c6b36.svg";